import {READ_LEADERBOARD, READ_LEADERBOARD_SUCCESS} from '../Types/Leaderboard';


export const readLeaderboardAction = () => {
    console.log("readLeaderboardAction");
    return {
        type: READ_LEADERBOARD,
    }
};

export const readLeaderboardSuccessAction = leaderboard => ({
    type: READ_LEADERBOARD_SUCCESS,
    payload: leaderboard
});






// WEBPACK FOOTER //
// ./src/Actions/LeaderboardActions.js